import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import React, { useState } from 'react';
import InnerLoader from '../Shared/Loader/InnerLoader';

function DowngradeDialog({
    oldPlanName, oldPlanInterval, oldSeats,
    nextPlanName, nextPlanInterval, nextSeats,
    planEndDate, isPlanDowngrade,
    onClose, onConfirm
}) {

    const [loading, setLoading] = useState(false);

    async function handleConfirm() {
        try {
            setLoading(true);
            await onConfirm();
        } finally {
            setLoading(false);
        }
    }

    return (
        <Dialog
            title="Change of Your Plan"
            width={"30%"}
            onClose={onClose}>
            <div className='d-flex'>
                <div className='d-flex align-items-center'>
                    <i className="fas fa-exclamation-triangle text-danger display-7 me-3 font-size-6"></i>
                </div>
                <div>
                    <p className='my-1 font-size-2'>
                        Below is the summary of your scheduled plan change.
                    </p>
                    <br />
                    <p className='my-1 font-size-2'>
                        Current Plan - <b>{oldPlanName} - {oldPlanInterval} - {oldSeats}</b>
                    </p>
                    <p className='my-1 font-size-2'>
                        New Plan: <b>{nextPlanName} - {nextPlanInterval} - {nextSeats}</b>.
                    </p>
                    <p className='my-1 font-size-2'>
                        Effective date of the new plan: <b>{ planEndDate }</b>.
                    </p>
                    <br />
                    {
                        isPlanDowngrade &&
                        <p className='my-1 font-size-2'>
                            This downgrade may affect your access to some features and capabilities in the new plan.
                        </p>
                    }
                    <p className='my-1 font-size-2'>
                        Are you sure you want to proceed?
                    </p>
                </div>
            </div>
            <DialogActionsBar layout='end'>
                <div className='mb-4 me-3 pe-2 d-flex align-items-center'>
                    { loading && <InnerLoader borderColor="red" /> }
                    <button className='btn btn-primary' onClick={onClose}>Stay in the current plan</button>
                    <button className='btn btn-danger' onClick={handleConfirm}>Confirm Downgrade</button>
                </div>
            </DialogActionsBar>
        </Dialog>
    )
}

export default DowngradeDialog;